import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PostgrestTransformBuilder from './PostgrestTransformBuilder';

var PostgrestFilterBuilder = /*#__PURE__*/function (_PostgrestTransformBu) {
  _inherits(PostgrestFilterBuilder, _PostgrestTransformBu);

  var _super = _createSuper(PostgrestFilterBuilder);

  function PostgrestFilterBuilder() {
    var _this;

    _classCallCheck(this, PostgrestFilterBuilder);

    _this = _super.apply(this, arguments);
    /** @deprecated Use `contains()` instead. */

    _this.cs = _this.contains;
    /** @deprecated Use `containedBy()` instead. */

    _this.cd = _this.containedBy;
    /** @deprecated Use `rangeLt()` instead. */

    _this.sl = _this.rangeLt;
    /** @deprecated Use `rangeGt()` instead. */

    _this.sr = _this.rangeGt;
    /** @deprecated Use `rangeGte()` instead. */

    _this.nxl = _this.rangeGte;
    /** @deprecated Use `rangeLte()` instead. */

    _this.nxr = _this.rangeLte;
    /** @deprecated Use `rangeAdjacent()` instead. */

    _this.adj = _this.rangeAdjacent;
    /** @deprecated Use `overlaps()` instead. */

    _this.ov = _this.overlaps;
    return _this;
  }
  /**
   * Finds all rows which doesn't satisfy the filter.
   *
   * @param column  The column to filter on.
   * @param operator  The operator to filter with.
   * @param value  The value to filter with.
   */


  _createClass(PostgrestFilterBuilder, [{
    key: "not",
    value: function not(column, operator, value) {
      this.url.searchParams.append("".concat(column), "not.".concat(operator, ".").concat(value));
      return this;
    }
    /**
     * Finds all rows satisfying at least one of the filters.
     *
     * @param filters  The filters to use, separated by commas.
     * @param foreignTable  The foreign table to use (if `column` is a foreign column).
     */

  }, {
    key: "or",
    value: function or(filters) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          foreignTable = _ref.foreignTable;

      var key = typeof foreignTable === 'undefined' ? 'or' : "".concat(foreignTable, ".or");
      this.url.searchParams.append(key, "(".concat(filters, ")"));
      return this;
    }
    /**
     * Finds all rows whose value on the stated `column` exactly matches the
     * specified `value`.
     *
     * @param column  The column to filter on.
     * @param value  The value to filter with.
     */

  }, {
    key: "eq",
    value: function eq(column, value) {
      this.url.searchParams.append("".concat(column), "eq.".concat(value));
      return this;
    }
    /**
     * Finds all rows whose value on the stated `column` doesn't match the
     * specified `value`.
     *
     * @param column  The column to filter on.
     * @param value  The value to filter with.
     */

  }, {
    key: "neq",
    value: function neq(column, value) {
      this.url.searchParams.append("".concat(column), "neq.".concat(value));
      return this;
    }
    /**
     * Finds all rows whose value on the stated `column` is greater than the
     * specified `value`.
     *
     * @param column  The column to filter on.
     * @param value  The value to filter with.
     */

  }, {
    key: "gt",
    value: function gt(column, value) {
      this.url.searchParams.append("".concat(column), "gt.".concat(value));
      return this;
    }
    /**
     * Finds all rows whose value on the stated `column` is greater than or
     * equal to the specified `value`.
     *
     * @param column  The column to filter on.
     * @param value  The value to filter with.
     */

  }, {
    key: "gte",
    value: function gte(column, value) {
      this.url.searchParams.append("".concat(column), "gte.".concat(value));
      return this;
    }
    /**
     * Finds all rows whose value on the stated `column` is less than the
     * specified `value`.
     *
     * @param column  The column to filter on.
     * @param value  The value to filter with.
     */

  }, {
    key: "lt",
    value: function lt(column, value) {
      this.url.searchParams.append("".concat(column), "lt.".concat(value));
      return this;
    }
    /**
     * Finds all rows whose value on the stated `column` is less than or equal
     * to the specified `value`.
     *
     * @param column  The column to filter on.
     * @param value  The value to filter with.
     */

  }, {
    key: "lte",
    value: function lte(column, value) {
      this.url.searchParams.append("".concat(column), "lte.".concat(value));
      return this;
    }
    /**
     * Finds all rows whose value in the stated `column` matches the supplied
     * `pattern` (case sensitive).
     *
     * @param column  The column to filter on.
     * @param pattern  The pattern to filter with.
     */

  }, {
    key: "like",
    value: function like(column, pattern) {
      this.url.searchParams.append("".concat(column), "like.".concat(pattern));
      return this;
    }
    /**
     * Finds all rows whose value in the stated `column` matches the supplied
     * `pattern` (case insensitive).
     *
     * @param column  The column to filter on.
     * @param pattern  The pattern to filter with.
     */

  }, {
    key: "ilike",
    value: function ilike(column, pattern) {
      this.url.searchParams.append("".concat(column), "ilike.".concat(pattern));
      return this;
    }
    /**
     * A check for exact equality (null, true, false), finds all rows whose
     * value on the stated `column` exactly match the specified `value`.
     *
     * @param column  The column to filter on.
     * @param value  The value to filter with.
     */

  }, {
    key: "is",
    value: function is(column, value) {
      this.url.searchParams.append("".concat(column), "is.".concat(value));
      return this;
    }
    /**
     * Finds all rows whose value on the stated `column` is found on the
     * specified `values`.
     *
     * @param column  The column to filter on.
     * @param values  The values to filter with.
     */

  }, {
    key: "in",
    value: function _in(column, values) {
      var cleanedValues = values.map(function (s) {
        // handle postgrest reserved characters
        // https://postgrest.org/en/v7.0.0/api.html#reserved-characters
        if (typeof s === 'string' && new RegExp('[,()]').test(s)) return "\"".concat(s, "\"");else return "".concat(s);
      }).join(',');
      this.url.searchParams.append("".concat(column), "in.(".concat(cleanedValues, ")"));
      return this;
    }
    /**
     * Finds all rows whose json, array, or range value on the stated `column`
     * contains the values specified in `value`.
     *
     * @param column  The column to filter on.
     * @param value  The value to filter with.
     */

  }, {
    key: "contains",
    value: function contains(column, value) {
      if (typeof value === 'string') {
        // range types can be inclusive '[', ']' or exclusive '(', ')' so just
        // keep it simple and accept a string
        this.url.searchParams.append("".concat(column), "cs.".concat(value));
      } else if (Array.isArray(value)) {
        // array
        this.url.searchParams.append("".concat(column), "cs.{".concat(value.join(','), "}"));
      } else {
        // json
        this.url.searchParams.append("".concat(column), "cs.".concat(JSON.stringify(value)));
      }

      return this;
    }
    /**
     * Finds all rows whose json, array, or range value on the stated `column` is
     * contained by the specified `value`.
     *
     * @param column  The column to filter on.
     * @param value  The value to filter with.
     */

  }, {
    key: "containedBy",
    value: function containedBy(column, value) {
      if (typeof value === 'string') {
        // range
        this.url.searchParams.append("".concat(column), "cd.".concat(value));
      } else if (Array.isArray(value)) {
        // array
        this.url.searchParams.append("".concat(column), "cd.{".concat(value.join(','), "}"));
      } else {
        // json
        this.url.searchParams.append("".concat(column), "cd.".concat(JSON.stringify(value)));
      }

      return this;
    }
    /**
     * Finds all rows whose range value on the stated `column` is strictly to the
     * left of the specified `range`.
     *
     * @param column  The column to filter on.
     * @param range  The range to filter with.
     */

  }, {
    key: "rangeLt",
    value: function rangeLt(column, range) {
      this.url.searchParams.append("".concat(column), "sl.".concat(range));
      return this;
    }
    /**
     * Finds all rows whose range value on the stated `column` is strictly to
     * the right of the specified `range`.
     *
     * @param column  The column to filter on.
     * @param range  The range to filter with.
     */

  }, {
    key: "rangeGt",
    value: function rangeGt(column, range) {
      this.url.searchParams.append("".concat(column), "sr.".concat(range));
      return this;
    }
    /**
     * Finds all rows whose range value on the stated `column` does not extend
     * to the left of the specified `range`.
     *
     * @param column  The column to filter on.
     * @param range  The range to filter with.
     */

  }, {
    key: "rangeGte",
    value: function rangeGte(column, range) {
      this.url.searchParams.append("".concat(column), "nxl.".concat(range));
      return this;
    }
    /**
     * Finds all rows whose range value on the stated `column` does not extend
     * to the right of the specified `range`.
     *
     * @param column  The column to filter on.
     * @param range  The range to filter with.
     */

  }, {
    key: "rangeLte",
    value: function rangeLte(column, range) {
      this.url.searchParams.append("".concat(column), "nxr.".concat(range));
      return this;
    }
    /**
     * Finds all rows whose range value on the stated `column` is adjacent to
     * the specified `range`.
     *
     * @param column  The column to filter on.
     * @param range  The range to filter with.
     */

  }, {
    key: "rangeAdjacent",
    value: function rangeAdjacent(column, range) {
      this.url.searchParams.append("".concat(column), "adj.".concat(range));
      return this;
    }
    /**
     * Finds all rows whose array or range value on the stated `column` overlaps
     * (has a value in common) with the specified `value`.
     *
     * @param column  The column to filter on.
     * @param value  The value to filter with.
     */

  }, {
    key: "overlaps",
    value: function overlaps(column, value) {
      if (typeof value === 'string') {
        // range
        this.url.searchParams.append("".concat(column), "ov.".concat(value));
      } else {
        // array
        this.url.searchParams.append("".concat(column), "ov.{".concat(value.join(','), "}"));
      }

      return this;
    }
    /**
     * Finds all rows whose text or tsvector value on the stated `column` matches
     * the tsquery in `query`.
     *
     * @param column  The column to filter on.
     * @param query  The Postgres tsquery string to filter with.
     * @param config  The text search configuration to use.
     * @param type  The type of tsquery conversion to use on `query`.
     */

  }, {
    key: "textSearch",
    value: function textSearch(column, query) {
      var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          config = _ref2.config,
          _ref2$type = _ref2.type,
          type = _ref2$type === void 0 ? null : _ref2$type;

      var typePart = '';

      if (type === 'plain') {
        typePart = 'pl';
      } else if (type === 'phrase') {
        typePart = 'ph';
      } else if (type === 'websearch') {
        typePart = 'w';
      }

      var configPart = config === undefined ? '' : "(".concat(config, ")");
      this.url.searchParams.append("".concat(column), "".concat(typePart, "fts").concat(configPart, ".").concat(query));
      return this;
    }
    /**
     * Finds all rows whose tsvector value on the stated `column` matches
     * to_tsquery(`query`).
     *
     * @param column  The column to filter on.
     * @param query  The Postgres tsquery string to filter with.
     * @param config  The text search configuration to use.
     *
     * @deprecated Use `textSearch()` instead.
     */

  }, {
    key: "fts",
    value: function fts(column, query) {
      var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          config = _ref3.config;

      var configPart = typeof config === 'undefined' ? '' : "(".concat(config, ")");
      this.url.searchParams.append("".concat(column), "fts".concat(configPart, ".").concat(query));
      return this;
    }
    /**
     * Finds all rows whose tsvector value on the stated `column` matches
     * plainto_tsquery(`query`).
     *
     * @param column  The column to filter on.
     * @param query  The Postgres tsquery string to filter with.
     * @param config  The text search configuration to use.
     *
     * @deprecated Use `textSearch()` with `type: 'plain'` instead.
     */

  }, {
    key: "plfts",
    value: function plfts(column, query) {
      var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          config = _ref4.config;

      var configPart = typeof config === 'undefined' ? '' : "(".concat(config, ")");
      this.url.searchParams.append("".concat(column), "plfts".concat(configPart, ".").concat(query));
      return this;
    }
    /**
     * Finds all rows whose tsvector value on the stated `column` matches
     * phraseto_tsquery(`query`).
     *
     * @param column  The column to filter on.
     * @param query  The Postgres tsquery string to filter with.
     * @param config  The text search configuration to use.
     *
     * @deprecated Use `textSearch()` with `type: 'phrase'` instead.
     */

  }, {
    key: "phfts",
    value: function phfts(column, query) {
      var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          config = _ref5.config;

      var configPart = typeof config === 'undefined' ? '' : "(".concat(config, ")");
      this.url.searchParams.append("".concat(column), "phfts".concat(configPart, ".").concat(query));
      return this;
    }
    /**
     * Finds all rows whose tsvector value on the stated `column` matches
     * websearch_to_tsquery(`query`).
     *
     * @param column  The column to filter on.
     * @param query  The Postgres tsquery string to filter with.
     * @param config  The text search configuration to use.
     *
     * @deprecated Use `textSearch()` with `type: 'websearch'` instead.
     */

  }, {
    key: "wfts",
    value: function wfts(column, query) {
      var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          config = _ref6.config;

      var configPart = typeof config === 'undefined' ? '' : "(".concat(config, ")");
      this.url.searchParams.append("".concat(column), "wfts".concat(configPart, ".").concat(query));
      return this;
    }
    /**
     * Finds all rows whose `column` satisfies the filter.
     *
     * @param column  The column to filter on.
     * @param operator  The operator to filter with.
     * @param value  The value to filter with.
     */

  }, {
    key: "filter",
    value: function filter(column, operator, value) {
      this.url.searchParams.append("".concat(column), "".concat(operator, ".").concat(value));
      return this;
    }
    /**
     * Finds all rows whose columns match the specified `query` object.
     *
     * @param query  The object to filter with, with column names as keys mapped
     *               to their filter values.
     */

  }, {
    key: "match",
    value: function match(query) {
      var _this2 = this;

      Object.keys(query).forEach(function (key) {
        _this2.url.searchParams.append("".concat(key), "eq.".concat(query[key]));
      });
      return this;
    }
  }]);

  return PostgrestFilterBuilder;
}(PostgrestTransformBuilder);

export { PostgrestFilterBuilder as default };